export class ColumnChartData {
  public constructor (
    readonly employee: string,
    readonly duration: number,
    readonly capacity: number,
    readonly overtime: number,
    readonly absence: number,
    readonly durationTime: string,
    readonly capacityTime: string,
    readonly overtimeTime: string,
    readonly absenceTime: string,
  ) {}

  static createListFromResponse (data: any): Array<ColumnChartData> {
    return data.map((item: any) => {
      let overtime = 0
      if (item.capacity < 0) {
        overtime = item.capacity / -60
      }

      return new ColumnChartData(
        item.employee_name,
        Math.round(item.duration) / 100,
        Math.round(item.capacity / 60 * 100) / 100,
        overtime,
        Math.round(item.absences / 60 * 100) / 100,
        item.duration_time,
        item.capacity_time,
        overtime.toString(),
        item.absences_time
      )
    })
  }
}
